import React from 'react';
import * as Backend from "../../backend.js";
import * as util from "../../other/util.js";

// Shows all fleets of the player
class FleetOverview extends util.GameComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }

    refreshState() {
        Backend.getPlayerFleets((res) => {
            this.setState({ fleets: res.fleets });
        }
        );
    }

    render() {
        if (!this.hasCurrentState()) {
            return (<util.LoadingBar2 />);
        }

        let fleets = this.state.fleets;
        return (
            <div className="fade-in" key={Math.random()}>
                <h1>Fleets</h1>
                <table className="generic-list">
                    <thead style={{ fontSize: "14px" }}>
                        <tr>
                            <td>Name</td>
                            <td>Ships</td>
                            <td>Hull</td>
                            <td>Location</td>
                            <td>Task</td>
                            <td>Combat</td>
                        </tr>
                    </thead>
                    <tbody>
                        {fleets.map((fleet) => (this.renderFleet(fleet)))}
                    </tbody>
                </table>
                <br />
                <util.JsonDebug obj={fleets} />
            </div>
        );
    }

    renderFleet(fleet) {
        let location = fleet.location;
        const status = util.FleetStatus.getFleetStatus(fleet);
        if (location == null && status === "MOVE") {
            location = util.FleetStatus.getMoveStep(fleet).location;
        }
        let is_foreign_planet = location.owner_id && location.owner_id !== util.getGPS().player_id;

        return (
            <tr key={fleet.id}>
                <td>
                    <util.FleetLink fleetId={fleet.id} fleetName={fleet.name} />
                </td>
                <td>
                    {fleet.ship_count}
                </td>
                <td>
                    <span style={{ color: fleet.stats.sustained_damage > 0 ? "red" : undefined }}>
                        {fleet.ship_count === 0 ? "-" : Math.round((fleet.stats.structure - fleet.stats.sustained_damage) / fleet.stats.structure * 1000) / 10 + "%"}
                    </span>
                </td>
                <td>
                    {status === "MOVE" ? <span> &#8594; </span> : null}
                    <util.PlanetLink planet={location} showOwner={is_foreign_planet} />
                </td>
                <td>
                    <util.FleetStatus fleet={fleet} />
                    {fleet.finished ? <span>: <util.Timer date={fleet.finished} /></span> : null}
                </td>
                <td>
                    {fleet.is_combat_active ? <span><span style={{ color: "red" }}>Fighting: </span><util.Timer date={fleet.next_combat_tick} /></span> : "-"}
                </td>
            </tr>
        );
    }

    _renderLocation(fleet) {
        if (fleet.location) {
            return (<util.PlanetLink planet={fleet.location} showOwner={true} />);
        }
        return (<span>Deep space</span>);
    }
}

export default util.withNavigation(FleetOverview);